
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"39","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.422 16.096C1.985 16.096 0 18.02 0 20.383v13.716c0 2.363 1.985 4.287 4.422 4.287H9.73c.996 0 1.913-.326 2.654-.868V16.096h-7.96zM39.623 22.444c0-.981-.387-1.895-1.058-2.57a4.064 4.064 0 001.04-3.115c-.19-2.075-2.05-3.7-4.238-3.7h-10.04c.498-1.517 1.294-4.297 1.294-6.53C26.621 2.99 23.626 0 21.745 0c-1.688 0-2.894.955-2.946.994a.821.821 0 00-.304.638v5.535l-4.68 10.184-.196.1v17.495c1.323.626 2.997.964 4.063.964H32.6c1.77 0 3.32-1.198 3.683-2.851a3.686 3.686 0 00-.294-2.452 3.658 3.658 0 002.009-3.266c0-.578-.132-1.132-.382-1.633a3.656 3.656 0 002.007-3.264z","fill":"#006733"}})])
          )
        }
      }
    